import i18n from 'i18n';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { commentCodesTransferService } from 'services';
import { showNotification } from 'components';
import { NotificationType, QueryContextFromKeys, QueryParamModel } from 'models';
import { isListEnabled } from 'utils/queryHelpers';

type CommentCodesTransferContexts = QueryContextFromKeys<typeof commentCodesTransferKeys>;

export const commentCodesTransferKeys = {
  all: [{ scope: 'commentCodesTransfer' }] as const,
  lists: () => [{ ...commentCodesTransferKeys.all[0], entity: 'list' }] as const,
  list: (params?: QueryParamModel | null) =>
    [{ ...commentCodesTransferKeys.lists()[0], params }] as const,
  statuses: () => [{ ...commentCodesTransferKeys.all[0], entity: 'statuses' }] as const,
};

const fetchList = async ({ queryKey: [{ params }] }: CommentCodesTransferContexts['list']) =>
  commentCodesTransferService.getList(params);

export const useCommentCodesTransferList = (params?: QueryParamModel | null) => {
  return useQuery({
    queryKey: commentCodesTransferKeys.list(params),
    queryFn: fetchList,
    enabled: isListEnabled(params),
  });
};

export const useSyncCommentCodesMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => commentCodesTransferService.sync(),
    onSuccess: () => {
      showNotification({
        content: i18n.t('LEO_MEGJEGYZES_KODOK_ATVETEL.SYNC_SUCCESS'),
        type: NotificationType.SUCCESS,
      });
      queryClient.invalidateQueries({ queryKey: commentCodesTransferKeys.lists() });
    },
  });
};
